import getV10APIs from './v1.0';
import getV11APIs from './v1.1';
import getV12APIs from './v1.2';

// 버전별 API 데이터를 작업명 기준으로 병합
const mergeVersionsByTitle = (title, url, ...apiArrays) => {
  const allData = [];
  apiArrays.forEach(apis => {
    const api = apis.find(a => a.title === title);
    if (api?.data) allData.push(...api.data);
  });
  return allData.length > 0 ? { title, url, data: allData } : null;
};

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);
  const v11APIs = getV11APIs(userInfo);
  const v12APIs = getV12APIs(userInfo);

  const children = [
    mergeVersionsByTitle('작업 등록', '/doc/작업 등록', v12APIs, v11APIs),
    mergeVersionsByTitle('선택작업 등록', '/doc/선택작업 등록', v11APIs, v10APIs),
    mergeVersionsByTitle('작업결과 조회', '/doc/작업결과 조회', v10APIs),
    mergeVersionsByTitle('작업리스트 조회', '/doc/작업리스트 조회', v10APIs),
    mergeVersionsByTitle('작업 삭제', '/doc/작업 삭제', v11APIs)
  ].filter(Boolean);

  return { title: '작업', children };
};

export default data;
